module.exports = __webpack_public_path__ + "static/media/azores-getaways-logo.8d23acc3.svg";